var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.333V2.66634C12 1.92994 11.4031 1.33301 10.6667 1.33301H5.33333C4.59693 1.33301 4 1.92994 4 2.66634V13.333C4 14.0694 4.59693 14.6663 5.33333 14.6663H10.6667C11.4031 14.6663 12 14.0694 12 13.333ZM8 5.33301C8.7364 5.33301 9.33333 5.92994 9.33333 6.66634C9.33333 7.40274 8.7364 7.99967 8 7.99967C7.2636 7.99967 6.66667 7.40274 6.66667 6.66634C6.66667 5.92994 7.2636 5.33301 8 5.33301ZM9.6104 10.6663H6.38953C6.17313 10.6663 5.99827 10.4588 6.06527 10.2531C6.2392 9.71901 6.7412 9.33301 7.33327 9.33301H8.6666C9.25873 9.33301 9.76067 9.71894 9.9346 10.2531C10.0016 10.4588 9.8268 10.6663 9.6104 10.6663Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileUser);
export default __webpack_public_path__ + "static/media/mobile-user.ebe8aae90da6dcdd135d474aec07f32a.svg";
export { ForwardRef as ReactComponent };